import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=95ad267e&scoped=true&"
import script from "./SuppliersList.vue?vue&type=script&lang=js&"
export * from "./SuppliersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad267e",
  null
  
)

export default component.exports